import { camelcaseKeys } from 'src/utils/camelize-keys';

import { RawSearchResultItem, SearchResult, SearchType } from './_types';

/**
 * Normalize a raw search result item from the API into our SearchResult type.
 *
 * @param raw - Raw search result item from API
 * @param type - The search type this result belongs to
 * @returns Normalized SearchResult
 */
export function normalizeSearchResult(
  raw: RawSearchResultItem,
  type: SearchType
): SearchResult {
  const camelizedData = camelcaseKeys(raw.data?.json || {});

  return {
    id: raw.id,
    name: raw.term,
    aliases: raw.aliases || [],
    profileImage: raw.profile_image || camelizedData.image,
    phoneNumber: raw.phone_number,
    kioskPinRegistered: raw.kiosk_pin_registered,
    type,
    data: camelizedData,
  };
}

/**
 * Normalize multiple search results for a given type
 */
export function normalizeSearchResults(
  items: RawSearchResultItem[],
  type: SearchType
): SearchResult[] {
  return items.map((item) => normalizeSearchResult(item, type));
}
